import React from 'react';
import { CodeArtifact } from './types';
import { ArtifactCardRouter } from './ArtifactCardRouter';
import { EmptyState } from '../EmptyState';
interface Props {
  artifacts: CodeArtifact[];
  onAnswerHitl: (id: string, answer: string) => void;
  onJumpToSessionTab: () => void;
}
export function ArtifactsTab({
  artifacts,
  onAnswerHitl,
  onJumpToSessionTab
}: Props) {
  if (artifacts.length === 0) {
    return <div className="px-5 py-10" data-id="element-443">
        <EmptyState message="No artifacts yet. The agent hasn't produced anything." data-id="element-444" />
      </div>;
  }
  const sorted = [...artifacts].sort((a, b) => {
    const aPriority = a.kind === 'hitl-step' && a.status === 'pending' ? 0 : 1;
    const bPriority = b.kind === 'hitl-step' && b.status === 'pending' ? 0 : 1;
    return aPriority - bPriority;
  });
  return <div className="px-5 py-5 space-y-4" data-id="element-445">
      {sorted.map(artifact => <ArtifactCardRouter key={artifact.id} artifact={artifact} onAnswerHitl={onAnswerHitl} onViewInSession={onJumpToSessionTab} data-id="element-446" />)}
    </div>;
}